import React, { useState } from 'react';
import Condition from './Condition';

import './ConditionList.css'
import classnames from 'classnames'
import SideOverView from './SideOverView';

const ConditionList = (props) => {
  const { conditions } = props
  const { addCondition, editCondition, deleteCondition } = props
  // conditions[0].condition 유무로 조건 존재여부를 판단함
  console.log('conditions :', conditions);
  
  const [ editId, setEditId ] = useState(null)

  // Flags
  const conditionRenderFlag = conditions && conditions[0].condition !== null 
  const SOVRenderFlag = editId || editId === 0 && conditions.find((con) => (con.id === editId))
  
  const onConfirm = (value) => {
    editCondition(editId, value, () => {setEditId(null)})
  }

  const onCancel = (e) => {
    setEditId(null)
  }

  const onDelete = () => {
    deleteCondition(editId, () => {setEditId(null)})
  }

  const onFirstUpdate = () => {
    
  }

  const onClickCreateBtn = (e) => {
    console.log('e :', e);
    // 컨디션 추가
    if (conditionRenderFlag) {
      console.log('Add condition')
      addCondition((id) => {setEditId(id)})
      return
    }

    // 컨디션 init 생성
    setEditId(conditions[0].id)
  } 

  // Find condition by editId
  const _editCondition = SOVRenderFlag && conditions ? conditions.find((con) => (con.id === editId)) : null
  
  // Condition create button conditional text
  const create_btn_text = conditionRenderFlag ? '컨디션 추가' : '컨디션 생성하기'

  return (
    <React.Fragment>
    {
      conditionRenderFlag && (
        <React.Fragment>
          <div className='condition-list'>
            <ul className='list'>{
              conditions.map((condition, i) => (
                <Condition key={i} condition={condition} editId={editId} setId={setEditId} blur={(editId || editId === 0)} />
              ))
            }</ul>
          </div>
        </React.Fragment>
      )
    }
      <div className='con-btns'>
        <button className='custom-btn light-btn' onClick={onClickCreateBtn}> {create_btn_text} </button>
      </div>
      <SideOverView
        onConfirm={onConfirm}
        onCancel={onCancel}
        onDelete={onDelete}
        onFirstUpdate={onFirstUpdate}
        editId={editId}
        condition={SOVRenderFlag ? _editCondition : null}
        noDelBtn={ conditions ? conditions.findIndex((con) => (con.id === editId)) === 0 && _editCondition.condition === null : undefined }
      />
    </React.Fragment>
  )
}

export default ConditionList